import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faGithubAlt,
    faFacebook,
    faTwitter,
    faInstagram,
  } from "@fortawesome/free-brands-svg-icons";

export default function SocialFollow() {
  return (
    <section class="social-container">
      <div className="container px-5 py-10 mx-auto">
        <div className="text-center mb-10">
          <h3 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4 font-zen">Social Media</h3>
          <a href="https://github.com/SarahMarie73" className="github social">
            <FontAwesomeIcon icon={faGithubAlt} size="2x" />
          </a>
          <a
            href="https://www.facebook.com/sarahmarie.dev"
            className="facebook social"
          >
            <FontAwesomeIcon icon={faFacebook} size="2x" />
          </a>
          <a
            href="https://www.twitter.com/sarah_schlueter"
            className="twitter social"
          >
            <FontAwesomeIcon icon={faTwitter} size="2x" />
          </a>
          <a
            href="https://www.instagram.com/sarahmarie.js"
            className="instagram social"
          >
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
        </div>
      </div>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/components/SocialFollow.js